// extracted by mini-css-extract-plugin
module.exports = {"FAQBlockQuestions__list":"FAQBlockQuetions_FAQBlockQuestions__list__S23tK","FAQBlockQuestions__question":"FAQBlockQuetions_FAQBlockQuestions__question__qzb8Q"};